export default __webpack_public_path__ + "static/media/go-to-computer.5c8b193d.png";